// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gk7m","textarea":"styles_textarea__3R4ox"};